import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import "./styles/main.scss";
import { openDB } from "./localdb/indexeddb";
import { isIOS } from "./lib/networkUtils";

// Log device and environment info

// Initialize IndexedDB
openDB()
  .then(() => {})
  .catch((error) => {});

// Listen for online/offline events
window.addEventListener("online", () => {});

window.addEventListener("offline", () => {});

// Check and log Service Worker status
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((reg) => {});
    });
  });

  // Listen for service worker updates
  navigator.serviceWorker.addEventListener("controllerchange", () => {});
} else {
  if (isIOS() && !window.location.protocol.startsWith("https")) {
  }
}

// Hide loading fallback
const fallback = document.getElementById("loading-fallback");
if (fallback) {
  fallback.style.display = "none";
}

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
